import { render, staticRenderFns } from "./ComercioExteriorGeneral.vue?vue&type=template&id=1566a4d2&"
import script from "./ComercioExteriorGeneral.vue?vue&type=script&lang=js&"
export * from "./ComercioExteriorGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports